// extracted by mini-css-extract-plugin
export default {"cls1":"VeloSplitFab-PrimaryFab_cls1__fr7Aj","cls2":"VeloSplitFab-PrimaryFab_cls2__bJadw VeloSplitFab-PrimaryFab_cls1__fr7Aj"};